export default __webpack_public_path__ + "static/media/sucess-sync.c030d9cf.svg";